import React from "react";
import { ChatContainer } from "../../../../ui-kit/ChatMessage/ChatMessage";
import { Typography } from "../../../../ui-kit/Typography";
import { useWebTranslation } from "../../../../translations";
import { StepName, StepProps } from "../types";
import { useAllValidAnimals } from "components/Signup/store/selectors/animals";
import { useSignupStore } from "components/Signup/store/hooks";
import { addAnimal } from "components/Signup/store/slices/animals";
import { Badge, MiniBanner } from "ui-kit";
import FlowButtons from "components/Signup/components/FlowButtons/FlowButtons";
import { AnimalSummary } from "components/Signup/components/AnimalSummary";
import { Button } from "ui-kit/Button";
import Colors from "ui-kit/colors";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import { formatErrorMessage } from "utils/validation";
import {
  useError,
  useMetadata,
} from "components/Signup/store/selectors/metadata";
import { trackSignupEvent } from "components/Signup/analytics";

const SummaryMultipet = ({
  next,
  transitioning,
  previous,
  isValid,
}: StepProps) => {
  const { t } = useWebTranslation();

  const animals = useAllValidAnimals();
  const error = useError();
  const { fromApp } = useMetadata();

  const { dispatch, getState } = useSignupStore();

  return (
    <>
      <ChatContainer leaving={transitioning}>
        <div>
          <div
            style={{
              display: "flex",
              gap: 16,
              flexDirection: "column",
            }}
          >
            <Typography variant="h2" align="center" style={{ marginBottom: 8 }}>
              {t("signup.summary.title")}
            </Typography>
            {[...animals].reverse().map((animal, index) => {
              return (
                <AnimalSummary
                  key={animal.id}
                  animal={animal}
                  isOpen={index === 0}
                />
              );
            })}
            {!fromApp ? (
              animals.length > 1 ? (
                <Button
                  variant="default"
                  textColor="blue300"
                  title={
                    <>
                      {t("multipet_banner.button")}
                      <Badge
                        text={t("multipet_banner.badge")}
                        color={Colors.sun200}
                        style={{ padding: "4px 8px", marginInlineStart: 8 }}
                      />
                    </>
                  }
                  onPress={() => {
                    trackSignupEvent("ADD_ANIMAL" as StepName, 0, getState());
                    dispatch(addAnimal());
                  }}
                  style={{
                    position: "sticky",
                    bottom: 80,
                    background: Colors.blue100,
                  }}
                />
              ) : (
                <MiniBanner
                  buttonText={t("multipet_banner.button")}
                  title={t("multipet_banner.headline")}
                  description={t("multipet_banner.description", {
                    name: animals[0].name ?? "",
                  })}
                  onClick={() => {
                    trackSignupEvent("ADD_ANIMAL" as StepName, 0, getState());
                    dispatch(addAnimal());
                  }}
                  badgeText={t("multipet_banner.badge")}
                  imageUrl="/images/insurance/multipet.png"
                />
              )
            ) : null}
          </div>
        </div>
        {!!error && (
          <ErrorMessage>
            <Typography color="error">{formatErrorMessage(error)}</Typography>
          </ErrorMessage>
        )}
        <FlowButtons
          inProgress={transitioning}
          next={next}
          disabled={!isValid}
          previous={previous}
          backButton={false}
        />
      </ChatContainer>
    </>
  );
};

export default SummaryMultipet;
